import { DateTime } from "luxon";

const MOCK_BOOKINGS_STORAGE_KEY = "skgate:mock-bookings";
const MOCK_SESSIONS_STORAGE_KEY = "skgate:mock-sessions";

const TOUR_LIBRARY = [
  {
    tourUUID: "tour-madrid-highlights",
    slug: "madrid-highlights",
    position: 1,
    nameI18n: {
      en: "City Icons - Time pricing",
      es: "City Icons - Precio por tiempo",
      fr: "City Icons - Prix par duree",
      it: "City Icons - Prezzo per durata",
    },
    descriptionI18n: {
      en: "Demo case for showing multiple durations with a fixed price per selected time slot.",
      es: "Caso demo para mostrar varias duraciones con precio fijo segun el tiempo elegido.",
      fr: "Cas de demo pour montrer plusieurs durees avec un prix fixe selon le temps choisi.",
      it: "Caso demo per mostrare piu durate con prezzo fisso in base al tempo scelto.",
    },
    coverImage:
      "https://images.unsplash.com/photo-1539037116277-4db20889f2d4?auto=format&fit=crop&w=1600&q=80",
    images: [
      "https://images.unsplash.com/photo-1539037116277-4db20889f2d4?auto=format&fit=crop&w=1600&q=80",
      "https://images.unsplash.com/photo-1518638150340-f706e86654de?auto=format&fit=crop&w=1600&q=80",
      "https://images.unsplash.com/photo-1529156069898-49953e39b3ac?auto=format&fit=crop&w=1600&q=80",
    ],
    locations: [
      { locationUUID: "loc-mad-1", name: "Mercado Central", pivot: { position: 1 } },
      { locationUUID: "loc-mad-2", name: "Arco del Sol", pivot: { position: 2 } },
      { locationUUID: "loc-mad-3", name: "Parque del Lago", pivot: { position: 3 } },
    ],
    priceMin: 39,
    duration: 60,
    durations: [
      {
        duration: 60,
        price: 39,
        stripe_price_id: "price_mock_madrid_60",
      },
      {
        duration: 90,
        price: 55,
        stripe_price_id: "price_mock_madrid_90",
      },
      {
        duration: 120,
        price: 69,
        stripe_price_id: "price_mock_madrid_120",
      },
    ],
    uses_people_instead_of_times: false,
    show_vehicles_as_lowest_capacity: false,
    uses_people_and_times_pricing: false,
    prefer_lower_people_price_tier: false,
    frontend_uses_people_price_tiers: false,
  },
  {
    tourUUID: "tour-sunset-city-lights",
    slug: "sunset-city-lights",
    position: 2,
    nameI18n: {
      en: "Golden Hour - Per-person pricing",
      es: "Golden Hour - Precio por persona",
      fr: "Golden Hour - Prix par personne",
      it: "Golden Hour - Prezzo per persona",
    },
    descriptionI18n: {
      en: "Demo case for showing people-based pricing tiers inside a single duration selection.",
      es: "Caso demo para mostrar seleccion por tramos de personas dentro de una misma duracion.",
      fr: "Cas de demo pour montrer des paliers de prix selon le nombre de personnes dans une meme duree.",
      it: "Caso demo per mostrare fasce di prezzo per numero di persone all'interno della stessa durata.",
    },
    coverImage:
      "https://images.unsplash.com/photo-1505764706515-aa95265c5abc?auto=format&fit=crop&w=1600&q=80",
    images: [
      "https://images.unsplash.com/photo-1505764706515-aa95265c5abc?auto=format&fit=crop&w=1600&q=80",
      "https://images.unsplash.com/photo-1514565131-fce0801e5785?auto=format&fit=crop&w=1600&q=80",
      "https://images.unsplash.com/photo-1477959858617-67f85cf4f1df?auto=format&fit=crop&w=1600&q=80",
    ],
    locations: [
      { locationUUID: "loc-sunset-1", name: "Avenida Mirador", pivot: { position: 1 } },
      { locationUUID: "loc-sunset-2", name: "Terraza del Atardecer", pivot: { position: 2 } },
      { locationUUID: "loc-sunset-3", name: "Paseo del Rio", pivot: { position: 3 } },
    ],
    priceMin: 100,
    duration: 60,
    durations: [
      {
        duration: 60,
        price: 100,
        stripe_price_id: "price_mock_sunset_60",
        people_prices: [
          { min_people: 1, max_people: 5, price: 100 },
          { min_people: 6, max_people: 6, price: 120 },
        ],
      },
    ],
    uses_people_instead_of_times: true,
    show_vehicles_as_lowest_capacity: false,
    uses_people_and_times_pricing: true,
    prefer_lower_people_price_tier: true,
    frontend_uses_people_price_tiers: true,
  },
  {
    tourUUID: "tour-retiro-signature",
    slug: "retiro-signature",
    position: 3,
    nameI18n: {
      en: "Lakeside Signature - Auto per-person pricing",
      es: "Lakeside Signature - Precio por persona auto",
      fr: "Lakeside Signature - Prix par personne auto",
      it: "Lakeside Signature - Prezzo per persona auto",
    },
    descriptionI18n: {
      en: "Demo case where duration and people count are chosen in the same card, without choosing a vehicle manually.",
      es: "Caso demo donde se eligen duracion y cantidad de personas en la misma tarjeta, sin seleccionar vehiculo a mano.",
      fr: "Cas de demo ou la duree et le nombre de personnes se choisissent dans la meme carte, sans choisir le vehicule a la main.",
      it: "Caso demo in cui durata e numero di persone si scelgono nella stessa scheda, senza selezionare il veicolo a mano.",
    },
    coverImage:
      "https://images.unsplash.com/photo-1529156069898-49953e39b3ac?auto=format&fit=crop&w=1600&q=80",
    images: [
      "https://images.unsplash.com/photo-1529156069898-49953e39b3ac?auto=format&fit=crop&w=1600&q=80",
      "https://images.unsplash.com/photo-1518638150340-f706e86654de?auto=format&fit=crop&w=1600&q=80",
      "https://images.unsplash.com/photo-1539037116277-4db20889f2d4?auto=format&fit=crop&w=1600&q=80",
    ],
    locations: [
      { locationUUID: "loc-retiro-1", name: "Jardin Norte", pivot: { position: 1 } },
      { locationUUID: "loc-retiro-2", name: "Lago Central", pivot: { position: 2 } },
      { locationUUID: "loc-retiro-3", name: "Puerta de Arte", pivot: { position: 3 } },
    ],
    priceMin: 100,
    duration: 60,
    durations: [
      {
        duration: 60,
        price: 100,
        stripe_price_id: "price_mock_retiro_60",
        people_prices: [
          { min_people: 1, max_people: 5, price: 100 },
          { min_people: 6, max_people: 6, price: 120 },
        ],
      },
    ],
    uses_people_instead_of_times: true,
    show_vehicles_as_lowest_capacity: false,
    uses_people_and_times_pricing: true,
    prefer_lower_people_price_tier: true,
    frontend_uses_people_price_tiers: true,
  },
  {
    tourUUID: "tour-royal-palace-essentials",
    slug: "royal-palace-essentials",
    position: 4,
    nameI18n: {
      en: "Heritage Essentials - Per-vehicle pricing",
      es: "Heritage Essentials - Precio por vehiculo",
      fr: "Heritage Essentials - Prix par vehicule",
      it: "Heritage Essentials - Prezzo per veicolo",
    },
    descriptionI18n: {
      en: "Demo case with a fixed price per vehicle, without variations by people or duration.",
      es: "Caso demo con precio fijo por vehiculo, sin variaciones por personas ni por duracion.",
      fr: "Cas de demo avec prix fixe par v?hicule, sans variations selon le nombre de personnes ni la duree.",
      it: "Caso demo con prezzo fisso per veicolo, senza variazioni per persone o durata.",
    },
    coverImage:
      "https://images.unsplash.com/photo-1523731407965-2430cd12f5e4?auto=format&fit=crop&w=1600&q=80",
    images: [
      "https://images.unsplash.com/photo-1523731407965-2430cd12f5e4?auto=format&fit=crop&w=1600&q=80",
      "https://images.unsplash.com/photo-1502602898657-3e91760cbb34?auto=format&fit=crop&w=1600&q=80",
      "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=1600&q=80",
    ],
    locations: [
      { locationUUID: "loc-palace-1", name: "Palacio Historico", pivot: { position: 1 } },
      { locationUUID: "loc-palace-2", name: "Plaza de la Catedral", pivot: { position: 2 } },
      { locationUUID: "loc-palace-3", name: "Jardines Reales", pivot: { position: 3 } },
    ],
    priceMin: 89,
    duration: 75,
    durations: [
      {
        duration: 75,
        price: 89,
        stripe_price_id: "price_mock_palace_vehicle_75",
      },
    ],
    uses_people_instead_of_times: false,
    show_vehicles_as_lowest_capacity: true,
    uses_people_and_times_pricing: false,
    prefer_lower_people_price_tier: false,
    frontend_uses_people_price_tiers: false,
  },
];



const MODEL_LIBRARY = [
  {
    tuktukUUID: "model-comfort",
    model: "Comfort Cruiser",
    availableUnits: 4,
    maxPeople: 2,
    units: 2,
  },
  {
    tuktukUUID: "model-family",
    model: "Family Explorer",
    availableUnits: 3,
    maxPeople: 4,
    units: 4,
  },
  {
    tuktukUUID: "model-premium",
    model: "Premium Panorama",
    availableUnits: 2,
    maxPeople: 6,
    units: 6,
  },
];

const OPTIONAL_FIELDS = {
  timer: true,
  description: true,
  localizations: true,
  reservation_header_duration: false,
  custom_pick_up: false,
  custom_pickup_fee_enabled: false,
  custom_pickup_fee_amount: 0,
  custom_pickup_radius_km: null,
  legal_default: true,
  cancel_policy_default: true,
};

const USER_DATA = {
  data: {
    companyName: "The Stable Game Demo",
    companyLogo: "/SkLogo.svg",
    max_people: 6,
    contact_number: "34600000000",
    contact_email: "demo@thestablegame.com",
  },
};

const TEXTS_BY_PAGE = {
  common: {},
  confirmationScreen: {},
  tourInfo: {},
  timeSelection: {},
};

const buildResponse = (config, data, status = 200) => ({
  data,
  status,
  statusText: status >= 400 ? "ERROR" : "OK",
  headers: {},
  config,
  request: {},
});

const buildError = (config, status, data) => {
  const error = new Error(data?.message || `Mock request failed with ${status}`);
  error.config = config;
  error.response = buildResponse(config, data, status);
  return error;
};

const safeWindow = () => (typeof window !== "undefined" ? window : undefined);

const safeReadStorageJson = (key) => {
  try {
    const raw = safeWindow()?.localStorage?.getItem(key);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
};

const safeWriteStorageJson = (key, value) => {
  try {
    safeWindow()?.localStorage?.setItem(key, JSON.stringify(value));
  } catch {
    // noop
  }
};

const getCurrentLanguage = () => {
  try {
    const lang = safeWindow()?.localStorage?.getItem("i18nextLng");
    if (lang) return lang.split("-")[0];
  } catch {
    // noop
  }
  return "en";
};

const pickI18n = (value, locale = getCurrentLanguage()) => {
  if (typeof value === "string") return value;
  if (!value || typeof value !== "object") return "";

  return (
    value[locale] ||
    value[locale?.split?.("-")?.[0]] ||
    value.en ||
    Object.values(value).find((candidate) => typeof candidate === "string") ||
    ""
  );
};

const findTourBySlug = (slug) => TOUR_LIBRARY.find((tour) => tour.slug === slug);
const findTourById = (tourUUID) =>
  TOUR_LIBRARY.find((tour) => tour.tourUUID === tourUUID);

const serializeTourListItem = (tour) => ({
  tourUUID: tour.tourUUID,
  slug: tour.slug,
  slug_i18n: { en: tour.slug, es: tour.slug, fr: tour.slug, it: tour.slug },
  name: tour.nameI18n,
  description: tour.descriptionI18n,
  cover_image_uri: tour.coverImage,
  priceMin: tour.priceMin,
  duration: tour.duration,
  durations: tour.durations,
  position: tour.position,
  uses_people_instead_of_times: tour.uses_people_instead_of_times,
  show_vehicles_as_lowest_capacity: tour.show_vehicles_as_lowest_capacity,
  uses_people_and_times_pricing: tour.uses_people_and_times_pricing,
  prefer_lower_people_price_tier: tour.prefer_lower_people_price_tier,
  frontend_uses_people_price_tiers: tour.frontend_uses_people_price_tiers,
});

const serializeTourDetails = (tour) => ({
  tourUUID: tour.tourUUID,
  slug: tour.slug,
  token: "mock-public-token",
  originUrl: safeWindow()?.location?.origin || "https://demo.thestablegame.com",
  name: pickI18n(tour.nameI18n),
  description: pickI18n(tour.descriptionI18n),
  images: tour.images,
  priceMin: tour.priceMin,
  duration: tour.duration,
  durations: tour.durations,
  stripe_price_id: tour.durations[0]?.stripe_price_id || "price_mock_default",
  uses_people_instead_of_times: tour.uses_people_instead_of_times,
  show_vehicles_as_lowest_capacity: tour.show_vehicles_as_lowest_capacity,
  uses_people_and_times_pricing: tour.uses_people_and_times_pricing,
  prefer_lower_people_price_tier: tour.prefer_lower_people_price_tier,
  frontend_uses_people_price_tiers: tour.frontend_uses_people_price_tiers,
});

const buildUnavailableDates = () => {
  const start = DateTime.now().startOf("day");
  const out = [];

  for (let index = 0; index < 120; index += 1) {
    const date = start.plus({ days: index });
    const isBlocked = index % 6 === 2 || date.weekday === 1;
    if (isBlocked) {
      out.push(date.toFormat("yyyy-MM-dd"));
    }
  }

  return out;
};

const buildAvailableHours = ({ date, duration }) => {
  const requestedDate = DateTime.fromFormat(date || "", "yyyy-MM-dd");
  const safeDate = requestedDate.isValid ? requestedDate : DateTime.now();
  const durationMinutes = Number(duration || 0) || 60;
  const baseHours = [10, 12, 14, 16, 18];

  return baseHours
    .filter((hour, index) => (safeDate.day + index + durationMinutes) % 5 !== 0)
    .map((hour) => `${String(hour).padStart(2, "0")}:00`);
};

const buildNextAvailableSlot = () =>
  DateTime.now().plus({ days: 1 }).set({ hour: 10, minute: 0, second: 0, millisecond: 0 }).toSeconds();

const mapTuktukModels = (models = []) =>
  models
    .map((model) => {
      const details = MODEL_LIBRARY.find((item) => item.tuktukUUID === model?.value);
      if (!details) return null;
      const units = Math.max(1, Number(model?.units) || 1);

      return {
        id: details.tuktukUUID,
        label: `${details.model} × ${units}`,
      };
    })
    .filter(Boolean);

const createMockBooking = (payload = {}) => {
  const now = DateTime.now();
  const bookingUUID = `mock-booking-${now.toMillis()}`;
  const sessionId = `mock-session-${now.toMillis()}`;

  const metadata = {
    bookingUUID,
    sessionId,
    clientName: payload.name || "Demo Guest",
    clientEmail: payload.email || "demo@thestablegame.com",
    clientPhone: payload.phone || "+34 600 000 000",
    clientCountry: payload.country || "ES",
    adults: Number(payload.adults || payload.persons || 2) || 2,
    minorsTotal: Number(payload.minorsTotal || 0) || 0,
    tuktukModels: JSON.stringify(mapTuktukModels(payload.tuktukModels)),
    persons: Number(payload.persons || 2) || 2,
    tourUUID: payload.tourUUID || null,
    bookingStart: payload.bookingStart || null,
    bookingEnd: payload.bookingEnd || null,
    free: true,
  };

  const bookings = readStoredMockBookings();
  bookings[bookingUUID] = metadata;
  safeWriteStorageJson(MOCK_BOOKINGS_STORAGE_KEY, bookings);

  const sessions = safeReadStorageJson(MOCK_SESSIONS_STORAGE_KEY);
  sessions[sessionId] = metadata;
  safeWriteStorageJson(MOCK_SESSIONS_STORAGE_KEY, sessions);

  return metadata;
};

const parseConfigData = (data) => {
  if (!data) return {};
  if (typeof data === "object") return data;
  if (typeof data !== "string") return {};

  try {
    return JSON.parse(data);
  } catch {
    return {};
  }
};

const normalizePath = (rawUrl = "") => {
  const base = "https://mock.thestablegame.local";
  const parsed = new URL(rawUrl, base);
  const withoutApi = parsed.pathname.startsWith("/api/")
    ? parsed.pathname.slice(4)
    : parsed.pathname;
  return withoutApi.startsWith("/") ? withoutApi : `/${withoutApi}`;
};

export const readStoredMockBookings = () =>
  safeReadStorageJson(MOCK_BOOKINGS_STORAGE_KEY);

export const resetStoredMockBookings = () => {
  safeWriteStorageJson(MOCK_BOOKINGS_STORAGE_KEY, {});
  safeWriteStorageJson(MOCK_SESSIONS_STORAGE_KEY, {});
};

export const createMockAxiosAdapter = () => async (config) => {
  const method = String(config?.method || "get").toLowerCase();
  const path = normalizePath(config?.url || "");
  const params = config?.params || {};
  const body = parseConfigData(config?.data);

  try {
    if (method === "get" && path === "/userDataAPI/get-user-data") {
      return buildResponse(config, USER_DATA);
    }

    if (method === "get" && path === "/activatableAPI/getUserActivatables") {
      return buildResponse(config, { activatable: OPTIONAL_FIELDS });
    }

    if (method === "get" && path.startsWith("/texts/")) {
      const [, , page] = path.split("/");
      return buildResponse(config, TEXTS_BY_PAGE[page] || {});
    }

    if (method === "get" && path === "/toursAPI/get-list") {
      return buildResponse(config, {
        tours: TOUR_LIBRARY.map(serializeTourListItem),
      });
    }

    if (method === "get" && path.startsWith("/tour/details/")) {
      const slug = decodeURIComponent(path.split("/").pop() || "");
      const tour = findTourBySlug(slug);
      if (!tour) throw buildError(config, 404, { message: "Tour not found" });
      return buildResponse(config, serializeTourDetails(tour));
    }

    if (method === "get" && path === "/toursAPI/get-tour-by-slug") {
      const tour = findTourBySlug(params?.slug);
      if (!tour) throw buildError(config, 404, { message: "Tour not found" });
      return buildResponse(config, {
        ...serializeTourDetails(tour),
        selectedDuration: Number(params?.duration || tour.duration) || tour.duration,
      });
    }

    if (method === "get" && path === "/toursAPI/get-images") {
      const tour = findTourById(params?.tourUUID);
      if (!tour) throw buildError(config, 404, { message: "Tour images not found" });
      return buildResponse(config, tour.images);
    }

    if (method === "get" && path === "/toursAPI/get-locations") {
      const tour = findTourById(params?.tourUUID);
      if (!tour) throw buildError(config, 404, { message: "Tour locations not found" });
      return buildResponse(config, tour.locations);
    }

    if (method === "get" && /\/toursAPI\/.+\/next-available-slot$/.test(path)) {
      return buildResponse(config, {
        next_available_slot: buildNextAvailableSlot(),
      });
    }

    if (method === "get" && /\/toursAPI\/.+\/get-unavailable-days$/.test(path)) {
      return buildResponse(config, buildUnavailableDates());
    }

    if (method === "get" && /\/toursAPI\/.+\/get-available-hours$/.test(path)) {
      return buildResponse(config, {
        available_hours: buildAvailableHours({
          date: params?.date,
          duration: params?.duration,
        }),
      });
    }

    if (method === "get" && path === "/csrf-token") {
      return buildResponse(config, { csrf_token: "mock-csrf-token" });
    }

    if (method === "get" && path.startsWith("/getStripeToken/")) {
      return buildResponse(config, "");
    }

    if (method === "get" && path === "/tuktuksAPI/get-simple") {
      return buildResponse(config, MODEL_LIBRARY);
    }

    if (method === "post" && path === "/checkout") {
      const booking = createMockBooking(body);
      return buildResponse(config, {
        free_booking: true,
        url: `/reservation/success?booking_uuid=${booking.bookingUUID}&free=1`,
      });
    }

    if (method === "get" && path.startsWith("/booking-success/")) {
      const bookingUUID = decodeURIComponent(path.split("/").pop() || "");
      const booking = readStoredMockBookings()[bookingUUID];
      if (!booking) {
        throw buildError(config, 404, {
          success: false,
          message: "Mock booking not found",
        });
      }
      return buildResponse(config, { success: true, metadata: booking });
    }

    if (method === "get" && path.startsWith("/stripe/session/")) {
      const sessionId = decodeURIComponent(path.split("/").pop() || "");
      const booking = safeReadStorageJson(MOCK_SESSIONS_STORAGE_KEY)[sessionId];
      if (!booking) {
        throw buildError(config, 404, {
          success: false,
          message: "Mock stripe session not found",
        });
      }
      return buildResponse(config, { success: true, metadata: booking });
    }

    if (method === "get" && path.startsWith("/tours/")) {
      const tourUUID = decodeURIComponent(path.split("/").pop() || "");
      const tour = findTourById(tourUUID);
      if (!tour) throw buildError(config, 404, { message: "Tour not found" });
      return buildResponse(config, {
        ...serializeTourDetails(tour),
        title: pickI18n(tour.nameI18n),
      });
    }

    throw buildError(config, 404, {
      message: `Mock route not found for ${method.toUpperCase()} ${path}`,
    });
  } catch (error) {
    return Promise.reject(error);
  }
};
